<template>
    <ReactPage>
        <consumer-raffle-special-event-winner-report-page></consumer-raffle-special-event-winner-report-page>
    </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
    name: "ConsumerRaffleSpecialEventWinnerReport",
    components: {
        ReactPage
    }
}
</script>